import { useRef } from 'react'
import { t } from '@lingui/core/macro'

import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@jotta/ui/DropdownMenu'
import SvgBoldMoreVertical from '@jotta/ui/SvgBoldMoreVertical'

import { PhotoAction } from '../PhotoActions/PhotoActions'

export function MediaThumbActionsMenu({
  albumId,
  disabled,
}: {
  albumId?: string
  disabled?: boolean
}) {
  const triggerRef = useRef<HTMLButtonElement | null>(null)
  const openedWithKeyboardRef = useRef(false)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <button
          ref={triggerRef}
          type="button"
          className="h-8 w-8 rounded-full bg-black/40 p-1 text-white shadow-sm backdrop-blur data-[state=open]:bg-black/60 hover:bg-black/60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-m3-primary disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-black/40"
          aria-label={t`Photo actions`}
          data-testid="PhotoDropDownMenuButton"
          disabled={disabled}
          onPointerDown={() => {
            openedWithKeyboardRef.current = false
          }}
          onKeyDown={() => {
            openedWithKeyboardRef.current = true
          }}
        >
          <PlainBrandIcon icon={SvgBoldMoreVertical} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        data-skip-click
        className="rounded-xl bg-primary p-2 shadow-lg"
        onCloseAutoFocus={event => {
          if (openedWithKeyboardRef.current) {
            return
          }

          event.preventDefault()
          triggerRef.current?.blur()
        }}
      >
        <div className="flex flex-col gap-1">
          {albumId ? <PhotoAction.UseAsCoverPhoto albumId={albumId} /> : null}
          <PhotoAction.SharePhotos />
          <PhotoAction.DownloadPhotos />
          {albumId ? (
            <PhotoAction.RemoveFromAlbum />
          ) : (
            <PhotoAction.DeletePhotos />
          )}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
